import { render, staticRenderFns } from "./HistoricoUsuario.vue?vue&type=template&id=294cbbb2&"
import script from "./HistoricoUsuario.vue?vue&type=script&lang=js&"
export * from "./HistoricoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports